import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AppProvider } from "@/context/AppContext";
import { Toaster } from "@/components/ui/sonner";

import StoreLayout from "@/components/layout/StoreLayout";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import Categories from "@/pages/Categories";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import OrderConfirmation from "@/pages/OrderConfirmation";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Wishlist from "@/pages/Wishlist";
import Consultants from "@/pages/Consultants";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import WellnessGoal from "@/pages/WellnessGoal";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Account from "@/pages/Account";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminCoupons from "@/pages/admin/AdminCoupons";
import AdminEnquiries from "@/pages/admin/AdminEnquiries";
import AdminCustomers from "@/pages/admin/AdminCustomers";
import AdminConsultants from "@/pages/admin/AdminConsultants";
import AdminBlogs from "@/pages/admin/AdminBlogs";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminAudit from "@/pages/admin/AdminAudit";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminRoles from "@/pages/admin/AdminRoles";
import AdminInventory from "@/pages/admin/AdminInventory";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminBrands from "@/pages/admin/AdminBrands";
import AdminBrandProducts from "@/pages/admin/AdminBrandProducts";
import AdminImageReviews from "@/pages/admin/AdminImageReviews";
import AdminCatalogues from "@/pages/admin/AdminCatalogues";
import AdminApprovalCentre from "@/pages/admin/AdminApprovalCentre";
import AdminBrandDetail from "@/pages/admin/AdminBrandDetail";
import BrandLogin from "@/pages/brand/BrandLogin";
import BrandDashboard from "@/pages/brand/BrandDashboard";
import { ShareProduct, ShareCollection } from "@/pages/SharePages";
import AdminInvoiceTemplate from "@/pages/admin/AdminInvoiceTemplate";
import AdminCMS from "@/pages/admin/AdminCMS";
import AdminActivity from "@/pages/admin/AdminActivity";

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route element={<StoreLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/product/:slug" element={<ProductDetail />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/order-confirmation/:id" element={<OrderConfirmation />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/wishlist" element={<Wishlist />} />
            <Route path="/consultants" element={<Consultants />} />
            <Route path="/wellness/:slug" element={<WellnessGoal />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/account" element={<Account />} />
          </Route>

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="products" element={<AdminProducts />} />
            <Route path="brands" element={<AdminBrands />} />
            <Route path="brands/:brandId" element={<AdminBrandDetail />} />
            <Route path="brand-products" element={<AdminBrandProducts />} />
            <Route path="image-reviews" element={<AdminImageReviews />} />
            <Route path="catalogues" element={<AdminCatalogues />} />
            <Route path="approval" element={<AdminApprovalCentre />} />
            <Route path="categories" element={<AdminCategories />} />
            <Route path="inventory" element={<AdminInventory />} />
            <Route path="orders" element={<AdminOrders />} />
            <Route path="invoice-template" element={<AdminInvoiceTemplate />} />
            <Route path="coupons" element={<AdminCoupons />} />
            <Route path="enquiries" element={<AdminEnquiries />} />
            <Route path="customers" element={<AdminCustomers />} />
            <Route path="consultants" element={<AdminConsultants />} />
            <Route path="blogs" element={<AdminBlogs />} />
            <Route path="website" element={<AdminCMS />} />
            <Route path="activity" element={<AdminActivity />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="roles" element={<AdminRoles />} />
            <Route path="audit" element={<AdminAudit />} />
            <Route path="settings" element={<AdminSettings />} />
            <Route path="*" element={<Navigate to="/admin" replace />} />
          </Route>

          <Route path="/brand-login" element={<BrandLogin />} />
          <Route path="/brand/login" element={<BrandLogin />} />
          <Route path="/brand" element={<BrandDashboard />} />
          <Route path="/share/p/:pid" element={<ShareProduct />} />
          <Route path="/share/c/:cid" element={<ShareCollection />} />
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
